export const navigation: any = {
  Admin: [
    {
      name: 'Dashboard',
      href: 'dashboard',
      access: 'All',
      submenu: [
        { name: 'Dispatch History', href: 'dispatch-history', path: 'full' }
      ],
    },
    {
      name: 'Products',
      href: 'products',
      access: 'All',
      submenu: [
        { name: 'Category', href: 'category' },
        { name: 'Products', href: 'products' },
        { name: 'Raw Material', href: 'part-material' },
      ],
    },
    {
      name: 'Sales',
      href: 'sales',
      access: 'All',
      submenu: [
        { name: 'Clients', href: 'clients' },
        { name: 'Sales Order', href: 'sales-order' },
        { name: 'Challan', href: 'challans' },
        {
          name: 'Quotations',
          href: 'quatations',
        },
        {
          name: 'Proforma Invoice',
          href: 'proforma',
        },
      ],
    },
    {
      name: 'Purchase',
      href: 'purchase',
      access: 'All',
      submenu: [
        { name: 'Suppliers', href: 'dealers' },
        {
          name: 'Purchase Orders',
          href: 'purchase-order',
        },
        {
          name: 'Purchase Report',
          href: 'purchase-inward',
        },
      ],
    },
    // {
    //   name: 'Account',
    //   href: 'account',
    //   access: 'All',
    //   submenu: [
    //     { name: 'Challans', href: 'challans' },
    //     { name: 'Order Ledger', href: 'order-ledger' },
    //   ],
    // },
    {
      name: 'Reports',
      href: 'reports',
      access: 'All',
      submenu: [
        { name: 'Sales Report', href: 'sales-report' },
        { name: 'Purchase Report', href: 'purchase-report' },
        { name: 'Product Stock', href: 'product-stock' },
        {
          name: 'Raw Material Stocks',
          href: 'material-stock',
        },
      ],
    },
    {
      name: 'Repairing',
      href: 'repairing',
      access: 'All',
      submenu: [
        { name: 'Repairing', href: 'repairing' },
        { name: 'Advanced Repairing', href: 'view-advanced' },
        { name: 'Repairing Reports', href: 'repairing-report' },
      ],
    },
    {
      name: 'Development',
      href: 'development',
      access: 'All',
      submenu: [
        { name: 'Development', href: 'development' },
        { name: 'PCB Parts', href: 'pcb-parts' },
        { name: 'PCB Category', href: 'pcb-management' },
      ],
    },
  ],
  Software: [
    {
      name: 'Dashboard',
      href: 'dashboard',
      access: 'All',
    },
    {
      name: 'Products',
      href: 'products',
      access: 'All',
      submenu: [
        { name: 'Category', href: 'category' },
        { name: 'Products', href: 'products' },
      ],
    },
    {
      name: 'Sales',
      href: 'sales',
      access: 'All',
      submenu: [
        { name: 'Sales Order', href: 'sales-order' },
      ],
    },
    {
      name: 'Development',
      href: 'development',
      access: 'All',
      submenu: [
        { name: 'Development', href: 'development' },
        { name: 'PCB Parts', href: 'pcb-parts' },
        { name: 'PCB Category', href: 'pcb-management' },
      ],
    },
  ],
};
